/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)


/**
 * Refers to app/javascript/stylesheets/application.scss (or application.css)
 * Note that we don't need to preface this path with "app/javascript" due to the `source_path` config set in config/webpacker.yml. Magical!
 * The file extension can be left off due to the `extensions` config in config/webpacker.yml.
 */
// import "stylesheets/application"

import "core-js/stable"
import "regenerator-runtime/runtime"

import '@fortawesome/fontawesome-free/js/all'


const contexts = [
  require.context("../components", true),
  // Incidents
  require.context('../components/incidents/dashboard', true),
  // UI
  require.context("../components/ui")
]
function fromRequireContexts(reqs) {
  return function (className) {
    let component;
    let parts = className.split('.');
    const filename = parts.shift();
    const keys = parts;

    // Search through all contexts for the component
    reqs.forEach(req => {
      const all_keys = req.keys();
      const matching_key = all_keys.find(k => k.endsWith(`/${filename}.jsx`) || k.endsWith(`/${filename}.js`));
      if (matching_key) {
        component = req(matching_key);
      }
    });

    // Handle `export default` and nested component paths
    if (component && component.__esModule && component.default) {
      component = component.default;
    }
    keys.forEach((k) => {
      if (component) {
        component = component[k];
      }
    });

    return component;
  };
}

var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.getConstructor = fromRequireContexts(contexts);

// window.componentRequireContext = componentRequireContext